import styled from "styled-components";

const primary = "#6c63ff";
const cardBg = "#ffffff";
const softGray = "#f0f2f5";
const textMain = "#2e2e3a";
const textSecondary = "#73758c";
const borderColor = "#e4e6f1";

export const Wrapper = styled.div`
  margin-bottom: 32px;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
`;

export const WeekNav = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

export const NavButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${borderColor};
  border-radius: 8px;
  background: ${cardBg};
  color: ${textMain};
  cursor: pointer;

  &:hover {
    border-color: ${primary};
    color: ${primary};
  }
`;

export const WeekTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${textMain};
  min-width: 190px;
  text-align: center;

  @media (max-width: 640px) {
    min-width: 0;
    font-size: 16px;
  }

  span {
    display: block;
    font-size: 12px;
    font-weight: 500;
    color: ${textSecondary};
  }
`;

export const TodayButton = styled.button`
  padding: 8px 12px;
  border: none;
  border-radius: 8px;
  background: ${softGray};
  color: ${primary};
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Chip = styled.button`
  padding: 7px 12px;
  border-radius: 999px;
  border: 1px solid ${({ active }) => (active ? primary : borderColor)};
  background: ${({ active }) => (active ? primary : cardBg)};
  color: ${({ active }) => (active ? "#fff" : textMain)};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;

export const DayStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 16px;
`;

export const DayTile = styled.div`
  padding: 10px 4px;
  border-radius: 12px;
  text-align: center;
  background: ${({ isToday }) => (isToday ? primary : cardBg)};
  color: ${({ isToday }) => (isToday ? "#fff" : textMain)};
  border: 1px solid ${({ isToday }) => (isToday ? primary : borderColor)};
  opacity: ${({ isPast, isToday }) => (isPast && !isToday ? 0.6 : 1)};
  cursor: ${({ empty }) => (empty ? "default" : "pointer")};
  transition: transform 0.15s ease;

  &:hover {
    transform: ${({ empty }) => (empty ? "none" : "translateY(-2px)")};
  }
`;

export const TileDay = styled.div`
  font-size: 12px;
  font-weight: 600;
  opacity: 0.8;
`;

export const TileDate = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
`;

export const TileCount = styled.div`
  font-size: 13px;
  font-weight: 700;
  opacity: ${({ empty }) => (empty ? 0.4 : 1)};
`;

export const Alert = styled.div`
  padding: 12px 14px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: #fff4e5;
  border: 1px solid #ffd59a;
  color: #7a4a00;
  font-size: 14px;
`;

export const AlertList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
`;

export const AlertItem = styled.button`
  padding: 4px 10px;
  border: 1px solid #ffd59a;
  border-radius: 999px;
  background: #fff;
  color: #7a4a00;
  font-size: 12px;
  cursor: pointer;
`;

export const DaySection = styled.section`
  margin-bottom: 14px;
  scroll-margin-top: 80px;
  opacity: ${({ isPast }) => (isPast ? 0.85 : 1)};
`;

export const DayHeader = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 700;
  color: ${({ isToday }) => (isToday ? primary : textMain)};
`;

export const DayCount = styled.span`
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 999px;
  background: ${softGray};
  color: ${textSecondary};
  font-size: 12px;
  text-align: center;
`;

export const EmptyDay = styled.div`
  padding: 8px 12px;
  border: 1px dashed ${borderColor};
  border-radius: 10px;
  color: ${textSecondary};
  font-size: 13px;
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  background: ${cardBg};
  border: 1px solid ${borderColor};
  border-left: 4px solid ${({ accent }) => accent};
  border-radius: 10px;
  opacity: ${({ removed }) => (removed ? 0.7 : 1)};

  @media (max-width: 640px) {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px 14px;
  }
`;

export const Time = styled.div`
  min-width: 56px;
  font-size: 18px;
  font-weight: 700;
  color: ${textMain};
  font-variant-numeric: tabular-nums;
`;

export const Body = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 640px) {
    flex: 1 1 calc(100% - 70px);
  }
`;

export const Name = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 600;
  color: ${textMain};
`;

export const Muted = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${textSecondary};
`;

export const Lang = styled.span`
  font-size: 12px;
  font-weight: 500;
`;

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 13px;
  color: ${textMain};

  svg {
    color: ${textSecondary};
  }
`;

export const Tag = styled.span`
  padding: 1px 8px;
  border-radius: 999px;
  background: ${softGray};
  color: ${textSecondary};
  font-size: 12px;
`;

export const Note = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: ${textSecondary};
  white-space: pre-wrap;

  svg {
    margin-right: 4px;
  }
`;

export const Status = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;

  @media (max-width: 640px) {
    flex: 1 1 100%;
    align-items: flex-start;
    padding-left: 70px;
  }
`;

export const Phone = styled.a`
  color: ${textMain};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: ${primary};
  }
`;

export const Flag = styled.span`
  padding: 1px 8px;
  border-radius: 999px;
  background: ${({ ok }) => (ok ? "#e8f5e9" : softGray)};
  color: ${({ ok }) => (ok ? "#2e7d32" : textSecondary)};
  font-size: 12px;
  white-space: nowrap;
`;

export const AlertHint = styled.div`
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.85;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  border-left: 4px solid ${({ color }) => color};
  background: ${softGray};
  font-size: 13px;
  white-space: nowrap;
`;

export const StatusSelect = styled.select`
  padding: 8px 10px;
  border: 1px solid ${borderColor};
  border-radius: 8px;
  background: ${cardBg};
  font-size: 13px;
  cursor: pointer;
`;
